module.exports = __webpack_public_path__ + "img/search.35b7f678.svg";